var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3CoolingFloor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 54H11V11h54v50zM19.28 31.73l4.21-1.8-3.81-2.2 2-3.46 3.81 2.2-.54-4.54 4-.48.9 7.52L36 32.54v-7.15l-6.06-4.54 2.4-3.2L36 20.4V16h4v4.4l3.66-2.74 2.4 3.2L40 25.39v7.14L46.19 29l.9-7.51 4 .47-.54 4.54 3.81-2.2 2 3.46-3.81 2.2 4.2 1.8-1.57 3.68-7-3L42 36l6.18 3.57 7-3 1.57 3.68-4.2 1.8 3.81 2.2-2 3.46-3.81-2.2.54 4.54-4 .47-.91-7.52L40 39.46v7.14l6.06 4.54-2.4 3.2L40 51.6V56h-4v-4.4l-3.66 2.74-2.4-3.2L36 46.61v-7.15L29.82 43l-.9 7.52-4-.48.54-4.54-3.81 2.2-2-3.46 3.81-2.2-4.21-1.8 1.57-3.68 7 3L34 36l-6.19-3.57-7 3-1.53-3.7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Cooling_floor.eebb6e72.svg";
export { SvgB3CoolingFloor as ReactComponent };